import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/CompassStyles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/CustomThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/InactivityMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/MainContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/MuiXLicense/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/lib/analytics/pushUserDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/lib/launchdarkly/LDProviderWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/styles/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"fallback\":[\"system-ui\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/fonts/Inter-VariableFont_opsz,wght.ttf\",\"weight\":\"400\",\"style\":\"normal\",\"display\":\"swap\"}],\"variableName\":\"localInter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ProvidersClientWrapper"] */ "/app/providers/ProvidersClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/providers/providerSwitch.tsx");
